import { AxiosPromise } from 'axios';
import { api } from './api';

export class BadgeAPI {
  static getBadgeUserDetails(id: string | number): AxiosPromise {
    return api.get(`/badges/${id}/user.jsonld`);
  }
}
